export default {
  title: 'Google Business',
  sections: {
    google_business_info: 'Google Business-info',
    google_reviews: 'Google-reviews',
    settings: 'Instellingen',
    danger_zone: 'Gevarenzone',
  },
  form: {
    reviews_autopilot_enabled: {
      label: 'AI-automatische antwoorden',
    },
    reviews_autopilot_daily_limit: {
      label: 'Dagelijks limiet AI-antwoorden (min. 1, max. 15)',
    },
    reviews_autopilot_delay_hours: {
      label: 'Aantal uren na het schrijven van een review',
    },
    unanswered_checkbox: {
      show_all_reviews: 'Alle reviews tonen',
      show_only_unanswered: 'Alleen onbeantwoorde tonen',
    },
    rating_filter: {
      label: 'Beoordelingsfilter',
      stars_one: '{{count}} ster',
      stars_other: '{{count}} sterren',
    },
    sorting: {
      newest_to_oldest: 'Sorteer van nieuwste naar oudste',
      oldest_to_newest: 'Sorteer van oudste naar nieuwste',
      rating_highest_to_lowest: 'Sorteer van hoogste naar laagste beoordeling',
      rating_lowest_to_highest: 'Sorteer van laagste naar hoogste beoordeling',
    },
  },
  table: {
    pagination: {
      total_one: 'Totaal {{count}} review',
      total_other: 'Totaal {{count}} reviews',
    },
  },
  modal_publish: {
    title: 'Weet u zeker dat u naar Google wilt publiceren?',
    buttons: {
      yes: 'Ja',
      cancel: 'Annuleren',
    },
  },
  popconfirm: {
    title: 'Weet u het zeker?',
    description: 'Alle lokale wijzigingen worden overschreven',
  },
  disconnect_profile: {
    title: 'Profiel ontkoppelen',
    button: 'Doorgaan',
    popconfirm: {
      title: 'Weet u het zeker?',
      description:
        'Dit ontkoppelt dit Google-profiel volledig van het Foodamigos-systeem, inclusief automatische linkvervangingen en automatische reviewantwoorden!',
    },
  },
  buttons: {
    login_with_google: 'Inloggen met Google',
    sync_from_google: 'Nieuwe versie ophalen',
    publish_to_google: 'Publiceren naar Google',
    previous: 'Vorige',
    next: 'Volgende',
    save_settings: 'Instellingen opslaan',
  },
  toasts: {
    failed_to_save_changes: 'Opslaan van wijzigingen mislukt',
    failed_to_fetch_reviews: 'Ophalen van reviews mislukt',
    failed_to_fetch_settings: 'Ophalen van instellingen mislukt',
    failed_to_load_google_business: 'Laden van Google Business mislukt',
    failed_to_publish_to_google_business: 'Publiceren naar Google Business mislukt',
    publish_access_denied:
      'Google heeft de update geweigerd: het gekoppelde Google-account kan dit Bedrijfsprofiel niet meer bewerken. Controleer de toegang in Google Business Profile of koppel opnieuw met het account dat het restaurant beheert.',
    failed_to_fetch_info: 'Ophalen van nieuwe Google Business-versie mislukt',
    success_publish_to_google_business: 'Succesvol gepubliceerd naar Google Business',
    success_sync_from_google: 'Succesvol gesynchroniseerd vanuit Google Business',
    success_save_settings: 'Instellingen succesvol opgeslagen',
    failed_to_disconnect_profile: 'Ontkoppelen van Google Business mislukt, neem contact op met het technische team!',
    popup_blocked: 'Sta pop-ups toe voor deze site om Google Business te koppelen.',
    failed_to_connect: 'Google Business kon niet worden gekoppeld. Probeer het opnieuw.',
    no_business_profile:
      'Dit Google-account beheert geen bedrijfsprofiel. Log in met het Google-account dat het restaurant beheert.',
  },
  callback: {
    connecting: 'Google Business wordt gekoppeld…',
    connected: 'Google Business is gekoppeld. U kunt dit venster sluiten.',
    cancelled: 'Het inloggen is geannuleerd. U kunt dit venster sluiten.',
    failed: 'Google Business kon niet worden gekoppeld. Sluit dit venster en probeer het opnieuw.',
  },
  alerts: {
    no_profile: {
      title: 'Geen Google Place gekoppeld',
      description: 'Koppel het restaurant aan een Google Place.',
      button: {
        connect: 'Koppelen',
      },
    },
    unverified_location: {
      title: 'Google Business is niet geverifieerd',
      description: 'Verifieer uw Google Business om door te gaan',
    },
  },
};
